import React from 'react'

import SliderHorizontal from 'views/components/organisms/SliderHorizontal'
import HorizontalSliderItem from 'views/components/organisms/SliderHorizontal/ProductSliderItem'

import { VISIBLE_COUNT_MOBILE_DEFAULT } from 'views/consts'

const renderSliderItems = products =>
  products.map(product => <HorizontalSliderItem product={product} thumbnail />)

export const getProductsSlider = (title, products) => (
  <>
    <h3>{title}</h3>
    <SliderHorizontal
      {...{
        items: renderSliderItems(products),
        visibleItemCount: 3,
        visibleItemCountTiny: VISIBLE_COUNT_MOBILE_DEFAULT,
        adaptableArrows: true
      }}
    />
  </>
)

const renderListItem = item => (
  <li key={`category-${item.id}`}>
    <a href={item.canonicalUrl}>{item.name}</a>
  </li>
)

const renderList = (title, items) => (
  <>
    <h3>{title}</h3>
    <ul className="a-list-reset">{items.map(item => renderListItem(item))}</ul>
  </>
)

export const getCategoriesList = (title, categories) =>
  renderList(title, categories)

export const getTopicsList = (title, topics) => renderList(title, topics)
